export default __webpack_public_path__ + "static/media/mail.7089e375.svg";